import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from "primeng/primeng";
import { QueryOperator } from "../../shared/_utils/services/query-operator.enum";
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { FiveYear } from "../entities/five-year";


@Injectable()
export class FiveYearService extends BaseCrudService<FiveYear> {

  public uri = '/api/fiveYear/';

  constructor(injector: Injector){
      super(injector);
     //console.log('Instance fiveYearService');
  }

  buildSentence(entity?: FiveYear, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ? 
          `row${QueryOperator.Equal}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.documentNumber ? 
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity.documentDate ? 
          `documentDate${QueryOperator.Equal}${entity.documentDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.supportingDocument && entity.supportingDocument.id) {
      query = query.concat(
          `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
        );
      }
      if (entity.jobTitle && entity.jobTitle.id) {
      query = query.concat(
          `jobTitle.id${QueryOperator.Equal}${entity.jobTitle.id}${QueryOperator.Split}`
        );
      }
      if (entity.payScale && entity.payScale.id) {
      query = query.concat(
          `payScale.id${QueryOperator.Equal}${entity.payScale.id}${QueryOperator.Split}`
        );
      }              
      if (entity.employee && entity.employee.id) {
      query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      query = query.concat(
        entity.comment ? 
          `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }
}


// WEBPACK FOOTER //
// ./src/app/core/services/five-year.service.ts